<template>
  <container>
    <div class="container">
      <div class="terms-page page">
        <div class="page__header">
          <h2>Terms and Conditions</h2>
        </div>
        <div class="page__card mt-0">
          <div
            class="page__card__content page__card__content--lg"
            v-html="content"
          ></div>
        </div>
      </div>
    </div>
  </container>
</template>
<script>
/**
 * ==================================================================================
 * Privacy Policy page
 * ==================================================================================
 **/

import { mapState, mapMutations, mapActions } from 'vuex'
import MainLayout from '@/layouts/MainLayout'

export default {
  metaInfo: function() {
    const title = 'Terms and Conditions'
    return {
      title: title,
      meta: [
        {
          property: 'og:title',
          content: title
        }
      ]
    }
  },
  components: {
    container: MainLayout
  },

  data() {
    return {
      loading: false,
      error: null
    }
  },

  computed: {
    ...mapState({
      terms: state => state.support.termsDetails
    }),

    content() {
      if (this.error) return this.error
      return this.terms ? this.terms.content : null
    }
  },

  methods: {
    ...mapActions({
      getTermsDetails: 'support/getTermsDetails'
    }),

    ...mapMutations({
      clearTermsDetails: 'support/clearTermsDetails'
    }),

    async fetchTerms() {
      if (this.loading) return
      this.error = null
      this.loading = true
      await this.getTermsDetails()
        .then(() => {
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.error = `Can't seem to fetch the terms and conditions, please try again later or refresh the page`
        })
    }
  },

  created() {
    this.clearTermsDetails()
    this.fetchTerms()
  }
}
</script>
<style scoped lang="scss">
.terms-page {
  .page__card__content {
    padding-top: 50px;
  }
}
</style>
